<template>
  <div class="grid mt-5">
    <vs-row class="mt-5">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          :label="$t('name') | capitalize"
          v-model="data.name"
          class="w-full"
          name="name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first('name')
        }}</span>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          type="rfc"
          :label="$t('rfc') | upperCase"
          v-model="data.rfc"
          class="w-full"
          name="rfc"
          v-validate="'required|min:12'"
        />
        <span class="text-danger text-sm" v-show="errors.has('rfc')">{{
          errors.first('rfc')
        }}</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-5">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          type="mail"
          :label="$t('email') | capitalize"
          v-model="data.email"
          class="w-full"
          name="email"
          v-validate="'required|email'"
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first('email')
        }}</span>
      </vs-col>
      <!-- <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          type="mail"
          :label="$t('other_emails') | capitalize"
          v-model="data.otherEmails"
          class="w-full"
          name="other_email"
        />
      </vs-col> -->
    </vs-row>
    <vs-row class="mt-5">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4" class="px-2">
        <vs-input
          :label="$t('contry') | capitalize"
          v-model="data.addressCountry"
          class="w-full"
          name="addressCountry"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('addressCountry')"
          >{{ errors.first('addressCountry') }}</span
        >
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4" class="px-2">
        <vs-input
          :label="$t('city') | capitalize"
          v-model="data.addressCity"
          class="w-full"
          name="addressCity"
        />
        <span class="text-danger text-sm" v-show="errors.has('addressCity')">{{
          errors.first('addressCity')
        }}</span>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4" class="px-2">
        <vs-input
          :label="$t('state') | capitalize"
          v-model="data.addressState"
          class="w-full"
          name="addressState"
        />
        <span class="text-danger text-sm" v-show="errors.has('addressState')">{{
          errors.first('addressState')
        }}</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-5">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          :label="($t('address') + ' 1') | capitalize"
          v-model="data.address1"
          class="w-full"
          name="address1"
        />
        <span class="text-danger text-sm" v-show="errors.has('address1')">{{
          errors.first('address1')
        }}</span>
      </vs-col>

      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          :label="$t('number') | capitalize"
          v-model="data.addressNumber"
          class="w-full"
          name="addressNumber"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('addressNumber')"
          >{{ errors.first('addressNumber') }}</span
        >
      </vs-col>
    </vs-row>
    <vs-row class="mt-5">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          :label="($t('address') + ' 2') | capitalize"
          v-model="data.address2"
          class="w-full"
          name="address2"
        />
        <span class="text-danger text-sm" v-show="errors.has('address2')">{{
          errors.first('address2')
        }}</span>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-input
          :label="$t('zip') | capitalize"
          v-model="data.addressZip"
          class="w-full"
          name="addressZip"
        />
        <span class="text-danger text-sm" v-show="errors.has('addressZip')">{{
          errors.first('addressZip')
        }}</span>
      </vs-col>
    </vs-row>
    <vs-row class="mt-5">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6" class="px-2">
        <vs-checkbox v-model="data.ignoreTaxes" class="mt-6 checkbox-center">
          <span class="text-xl">
            {{ $t('ingnore_taxes') | capitalize }}
          </span>
        </vs-checkbox>
      </vs-col>
    </vs-row>
    <vs-row class="mt-5" vs-justify="flex-end">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="2" class="px-2">
        <vs-button
          color="primary"
          type="filled"
          class="w-full"
          @click="handleSubmit"
           v-if="hasPermission(['IU VENDORS EDIT'])"
        >
          {{ $t('save') | capitalize }}
        </vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import request from '../request'
import loading from '@/mixins/Loading'
export default {
  props: ['vendorId'],
  data() {
    return {
      data: {
        name: '',
        rfc: '',
        email: '',
        address1: '',
        address2: '',
        addressCountry: '',
        addressState: '',
        addressCity: '',
        addressNumber: '',
        addressZip: '',
        ignoreTaxes: false,
      },
    }
  },
  computed: {
    disabledSubmit() {
      return (
        this.errors.any() ||
        this.form.bank === '' ||
        this.form.account === '' ||
        this.form.currency === ''
      )
    },
  },
  methods: {
    getVendor() {
      this.openLoading(`vendor-details-loading`)
      request
        .getVendor(this.vendorId)
        .then((response) => {
          this.data.name = response.data.vendor.VendorName
          this.data.rfc = response.data.vendor.RFC
          this.data.email = response.data.vendor.Email
          this.data.address1 = response.data.vendor.Address1
          this.data.address2 = response.data.vendor.Address2
          this.data.addressCountry = response.data.vendor.AddressCountry
          this.data.addressState = response.data.vendor.AddressState
          this.data.addressCity = response.data.vendor.AddressCity
          this.data.addressNumber = response.data.vendor.AddressNumber
          this.data.addressZip = response.data.vendor.AddressZip
          this.data.ignoreTaxes =
            response.data.vendor.IgnoreTaxes == '0' ? false : true
          this.closeLoading(`vendor-details-loading`)
        })
        .catch((response) => {
          this.closeLoading(`vendor-details-loading`)
          this.showValidationErrors(response)
        })
    },
    handleSubmit() {
      const payload = {
        name: this.data.name,
        rfc: this.data.rfc,
        email: this.data.email,
        address1: this.data.address1,
        address2: this.data.address2,
        addressCountry: this.data.addressCountry,
        addressState: this.data.addressState,
        addressCity: this.data.addressCity,
        addressNumber: this.data.addressNumber,
        addressZip: this.data.addressZip,
        ignoreTaxes: this.data.ignoreTaxes == false ? 0 : 1,
      }
      this.openLoading(`vendor-details-loading`)
      request
        .updateVendor(this.vendorId, payload)
        .then((response) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Vendor Updated',
          })
          this.closeLoading(`vendor-details-loading`)
        })
        .catch((response) => {
          this.closeLoading(`vendor-details-loading`)
          this.showValidationErrors(response)
        })
    },
    openSidebar(data = {}) {
      this.vendorAccount = { ...data }
      this.$store.dispatch('toggleSidebar', 'vendor-account-sidebar')
    },
  },
  mounted() {
    this.getVendor()
  },
  mixins: [loading],
}
</script>

<style>
</style>